(() => {
  const stockUrl = (href) => {
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return null;
    if (/\/collections\/[^/]+\/?$/.test(url.pathname)) {
      url.searchParams.set('filter.v.availability', '1');
    } else if (/\/search\/?$/.test(url.pathname)) {
      url.searchParams.set('options[unavailable_products]', 'hide');
    } else {
      return null;
    }
    return url.pathname + url.search + url.hash;
  };
  const updateLink = (link) => {
    if (!link || !link.hasAttribute('href')) return;
    const next = stockUrl(link.getAttribute('href'));
    if (next && link.getAttribute('href') !== next) link.setAttribute('href', next);
  };
  const updateForm = (form) => {
    const action = new URL(form.action || window.location.href, window.location.href);
    if (action.origin !== window.location.origin || !/\/search\/?$/.test(action.pathname)) return;
    let input = form.querySelector('input[name="options[unavailable_products]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'options[unavailable_products]';
      form.append(input);
    }
    input.value = 'hide';
  };
  const update = () => {
    document.querySelectorAll('a[href]').forEach(updateLink);
    document.querySelectorAll('form').forEach(updateForm);
  };
  const pendingPages = new WeakSet();
  const loadPage = async (link) => {
    if (pendingPages.has(link)) return;
    const grid = document.querySelector('#main-collection-product-grid');
    if (!grid) return;
    const next = stockUrl(link.href);
    if (!next) return;
    pendingPages.add(link);
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');
    const url = new URL(next, window.location.origin);
    if (grid.dataset.id) url.searchParams.set('section_id', grid.dataset.id);
    try {
      const response = await fetch(url, {credentials: 'same-origin', headers: {Accept: 'text/html'}});
      if (!response.ok) throw new Error('Pagination request failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = html.querySelector('#main-collection-product-grid');
      const products = nextGrid ? Array.from(nextGrid.children).filter((item) => item.matches('li.product')) : [];
      if (!products.length) throw new Error('No product page returned');
      grid.append(...products);
      const currentPagination = link.closest('.pagination-wrapper');
      const nextPagination = html.querySelector('.pagination-wrapper');
      if (currentPagination && nextPagination) {
        const start = nextPagination.querySelector('[data-total-start]');
        if (start) start.textContent = '1';
        nextPagination.querySelectorAll('a[href]').forEach(updateLink);
        currentPagination.replaceWith(nextPagination);
      } else if (currentPagination) currentPagination.remove();
    } catch {
      window.location.assign(next);
    } finally {
      pendingPages.delete(link);
      link.classList.remove('is-loading');
      link.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    updateLink(link);
    if (link && link.matches('[data-infinite-scrolling]') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      event.stopImmediatePropagation();
      loadPage(link);
    }
  }, true);
  document.addEventListener('submit', (event) => updateForm(event.target), true);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once: true});
  else update();
})();
